export const CHANNELS_PATH = 'admin/channels';
